import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as userActions from '@/store/actions/user';
import * as badgeActions from '@/store/actions/badgeNum';
import * as msgNumActions from '@/store/actions/msgNum';
import * as boxActions from '@/store/actions/selectBox';
import * as appActions from '@/store/actions/app';
import { Link } from 'react-router-dom';
import history from '@/containers/history';
import { Scrollbars } from 'react-custom-scrollbars';
import { Menu, Badge, Dropdown, Popover, Avatar, Icon, Row, Col, message, Modal, Layout } from 'antd';
import { loginOut, getOrgList_box, getLabList_box, getRoleList_box, getDataList_box, getComboxList_box, getTrainUserList_box, getMsgNum, getlabRoleList_box, getLabUserList, switchLabHandle } from '@/api/api';
import servers from '@/api/server';
import styles from './SiderMenu.module.less';
import { reqByGet } from '../../api/api';

const SubMenu = Menu.SubMenu;
const { Sider } = Layout;
class SiderMenu extends Component {
  constructor(props) {
    super(props);
    console.log(props)
    console.log(props.user.treeList)
    let settingMenu;
    if (props.user.treeList && props.user.treeList.find(x => { return x.value === 279 })) {
      settingMenu = props.user.treeList.find(x => { return x.value === 279 })
    };
    console.log(settingMenu)
    this.state = {
      msgNum: 0,
      msgFlag: true,
      // msgFlag347: true,
      // msgFlag264: true,
      // msgFlag338: true,
      // msgFlag323: true,
      badge: {},
      menuList: this.props.user.treeList,
      settingMenu: settingMenu,
      curLab: {},
      logoImg: servers.defaultLogoPath
    }
    this.loginOut = this.loginOut.bind(this);
    // this.getMsgNum=this.getMsgNum.bind(this);
  }

  componentWillMount() {
    this.props.updateHeaderPanes([]);
    this.props.updateHeaderPaneKey('');

  }

  componentDidMount() {
    const that = this;
    that.state.menuList.length > 0 && that.state.menuList.map(item => {
      // let flag = true
      // if (item.name === '课题管理' && that.state.proNumAll === 0) {
      //   flag = false
      // } else if (item.name === '报告管理' && that.state.badge.reportNum === 0) {
      //   flag = false
      // } else if (item.name === '仪器设备' && that.state.eqAdminAll === 0) {
      //   flag = false
      // } else if (item.name === '经费管理' && that.state.badge.fundsNum === 0) {
      //   flag = false
      // } else if (item.name === '行政管理' && that.state.trainNum === 0) {
      //   flag = false
      // } else if (item.name === '试剂耗材' && that.state.medicineAll === 0) {
      //   flag = false
      // }
      that.setValue('msgFlag' + item.value, true)
    })
    this.props.updateBadge()

    console.log('------------------------------------------------------------------------------')
    console.log(this.props.badgeNum)
    this.setState({
      badge: this.props.badgeNum,
      medicineAll: this.props.badgeNum.reagentApplyNum + this.props.badgeNum.reagentNum + this.props.badgeNum.reagentbuyNum,
      eqAdminAll: this.props.badgeNum.eqApplyNum + this.props.badgeNum.noBackBespeak + this.props.badgeNum.repairEqNum,
      proNumAll: this.props.badgeNum.proNum + this.props.badgeNum.workReport,
      trainNum: this.props.badgeNum.questionnaireNum + this.props.badgeNum.trainNum
    })
    // reqByGet(servers.fristTO, {}, res => {
    //   this.setState({
    //     badge: res,
    //     medicineAll: res.reagentApplyNum + res.reagentNum + res.reagentbuyNum,
    //     eqAdminAll: res.eqApplyNum + res.noBackBespeak + res.repairEqNum,
    //     proNumAll: res.proNum + res.workReport,
    //     trainNum: res.questionnaireNum + res.trainNum
    //   }, () => {

    //   })
    // }, err => {
    //   console.log(err)
    // })

    that.props.updateMsgNum();
    let timer_theme = setInterval(function () {
      if (window.less.modifyVars) {
        window.less.modifyVars({
          '@primary-color': '#71ca98',
          '@btn-primary-bg': '#71ca98',
          // '@primary-color':'#' + that.props.user.color,
          // '@btn-primary-bg':'#' + that.props.user.color,
        });
        clearInterval(timer_theme)
      }
    }, 10)
    let httpStr = window.location.host.startsWith('http') ? '' : 'http://';
    this.setState({
      logoImg: httpStr + window.location.host + '/labpro' + this.props.user.dirPath + 'logo.png'
    })

    if (this.props.user.labList.length) {
      let curLab = this.props.user.labList.find(x => {
        return x.isDef === 2;
      });
      if (curLab) {
        that.setState({
          curLab
        })
      }
    }

    getRoleList_box({}, res => { //获取角色下拉列表
      that.props.role_input(res.roleBoxList)
    }, err => {
      console.log(err)
    })

    getlabRoleList_box({}, res => {
      that.props.labRole_input(res.roleBoxList)
    }, err => {
      console.log(err)
    })

    that.props.updateMsgNum();

    setTimeout(() => {
      that.props.updateMsgNum();
    }, 60000)
  }
  tochangeBadge = (res) => {
    this.setState({
      badge: res,
      medicineAll: res.reagentApplyNum + res.reagentNum + res.reagentbuyNum,
      eqAdminAll: res.eqApplyNum + res.noBackBespeak + res.repairEqNum,
      proNumAll: res.proNum + res.workReport,
      trainNum: res.questionnaireNum + res.trainNum
    })
  }
  componentWillUpdate() {
  }
  showRule() {
    let httpStr = 'http://m.daniulab.com/labpro//resources/Client/DN_V2.7z';
    let httpStr1 = 'http://m.daniulab.com/labpro/resources/document/（APP）大牛Lab实验室管理系统产品使用手册.pdf';
    let httpStr2 = 'http://m.daniulab.com/labpro/resources/document/（C端程序）大牛Lab实验室管理系统产品使用手册.pdf';
    let httpStr3 = 'http://m.daniulab.com/labpro/resources/document/（PC web）大牛Lab实验室管理系统产品使用手册.pdf';
    // http://52.81.91.72:9456/labpro/resources/document/（APP-normal）杂交水稻国家重点实验室管理系统产品使用手册.docx
    Modal.info({
      title: '系统操作手册下载链接',
      width: 442,
      content: (
        <div>
          <p>&nbsp;&nbsp;</p>
          <p></p>
          <p></p>
          <p></p>
          <p><a href={httpStr1} target='_blank'>（APP）大牛Lab实验室管理系统产品使用手册.pdf</a></p>
          <p><a href={httpStr2} target='_blank'>（C端程序）大牛Lab实验室管理系统产品使用手册.pdf</a></p>
          <p><a href={httpStr3} target='_blank'>（PC web）大牛Lab实验室管理系统产品使用手册.pdf</a></p>
          <p><a href={httpStr} target='_blank'>C端程序</a></p>
          {/* <p><a href={httpStr3} target='_blank'>（PC web）杂交水稻国家重点实验室管理系统产品使用手册2020-3-3.docx</a></p> */}
        </div>
      ),
      onOk() { },
    });
  }
  setValue = (file, value) => {
    this.setState({
      [file]: value
    })
  }
  // 获取消息数量
  // getMsgNum(){
  //   const that=this;
  //   getMsgNum({},res=>{
  //     if(res.msgNum){
  //       that.props.updateMsgNum(res.msgNum)
  //       that.setState({
  //         msgNum:res.msgNum
  //       })
  //     }
  //   },err=>{
  //     console.log(err)
  //   })
  // }

  // 退出登陆
  loginOut() {
    const that = this;
    loginOut({}, res => {
      that.props.loginOut();
    }, err => {
      console.log(err)
    })
  }

  handleClick(e) {
    console.log(e.key);
    console.log(e)
    this.setState({ current: e.key });
  }

  render() {
    const that = this;
    const { settingMenu, logoImg, current, badge } = this.state;
    const userMenu = (
      <ul className={styles.userMenu}>
        <li>
          <Link to="/userCenter">个人中心</Link>
        </li>
        <li onClick={() => this.loginOut()}>
          <a>退出登录</a>
        </li>
      </ul>
    );
    const helpMenus = (
      <div className='f14'>帮助</div>
    )
    const settingMenus = (
      <ul className={styles.userMenu}>
        {settingMenu && settingMenu.subMenu.map(item => {
          return (
            <li key={item.link}>
              <Link to={item.link}>{item.name}</Link>
            </li>
          )
        })}
      </ul>
    );
    return (
      <Sider className={`${styles.siderWrapper} siderWrapper`} id="siderWrapper" collapsed={true} collapsedWidth={95} style={{ background: '#fff' }}>
        <Link to="/homePage" className={styles.header_logo}><h1><img src={logoImg} alt="logo" /></h1></Link>
        <Scrollbars className='myScroll' style={{ height: '100%' }} autoHide>
          <Menu mode="inline" inlineCollapsed={true} inlineIndent={95} className="body_menu pr" defaultSelectedKeys={[]} selectedKeys={[current]} onClick={this.handleClick.bind(this)}>
            {this.state.menuList.length > 0 && this.state.menuList.map(item => {
              // this.setValue('msgFlag' + item.value, false)
              if (item.value === 1 || item.value === 279) {
                return
              };
              if (item.subMenu.length < 1) {
                // 这里需要后台配置菜单图标， 否则显示默认图标
                return (
                  <Menu.Item key={item.value} title={item.name} onMouseEnter={() => this.setValue('msgFlag', false)} onMouseLeave={() => this.setValue('msgFlag', true)}>
                    {/* <Icon type={item.icon || 'experiment'} /> */}
                    {item.name !== '通讯录' &&
                      <i className={`iconfont ${item.icon ? item.icon : 'icon-ziyuan'} ${screen.width == 1440 ? 'mr0 f20' : 'mydataIcon'}`}></i>
                    }
                    {item.name == '通讯录' && <i className={`iconfont ${item.icon} ${screen.width == 1440 ? 'mr0 f24' : 'mydataIcon2'}`}></i>}
                    <Link to={item.link}>
                      <span className='isSpan pr'>{item.name}
                      </span>
                    </Link>

                  </Menu.Item>

                )
              } else {
                let frFlag = this.state['msgFlag' + item.value];
                let badge = this.props.badgeNum
                let medicineAll = this.props.badgeNum.reagentApplyNum + this.props.badgeNum.reagentNum + this.props.badgeNum.reagentbuyNum
                let eqAdminAll = this.props.badgeNum.eqApplyNum + this.props.badgeNum.noBackBespeak + this.props.badgeNum.repairEqNum
                let proNumAll = this.props.badgeNum.proNum + this.props.badgeNum.workReport
                let trainNum = this.props.badgeNum.questionnaireNum + this.props.badgeNum.trainNum + this.props.badgeNum.meetingEqNum
                let projectFlag = this.props.badgeNum.projectFlag
                let administrativeFlag = this.props.badgeNum.administrativeFlag
                let reportFlag = this.props.badgeNum.reportFlag
                let fundsFlag = this.props.badgeNum.fundsFlag
                let equipmentFlag = this.props.badgeNum.equipmentFlag
                let reagentFlag = this.props.badgeNum.reagentFlag
                let pdFileFlag = this.props.badgeNum.pdFileFlag
                return (
                  // 这里需要后台配置菜单图标， 否则显示默认图标
                  <SubMenu popupClassName="body_submenu" onMouseEnter={() => this.setValue('msgFlag' + item.value, false)} onMouseLeave={() => this.setValue('msgFlag' + item.value, true)} key={item.value} title={
                    <span className='pr'>
                      {item.name === '课题管理' && projectFlag &&
                        <span>
                          {!frFlag &&
                            <span className='pa thisTospan1'>
                              {item.name === '课题管理' ? proNumAll : item.name === '报告管理' ? this.props.badgeNum.reportNum : item.name === '行政管理' ? trainNum : item.name === '试剂耗材' ? medicineAll : item.name === '仪器设备' ? eqAdminAll : item.name === '经费管理' ? this.props.badgeNum.fundsNum : item.name === '文件私盘' ? this.props.badgeNum.reqPdInteger : 0}
                            </span>}
                          {frFlag && <span className='pa thisTospan'></span>}
                        </span>
                      }
                      {item.name === '行政管理' && administrativeFlag &&
                        <span>
                          {!frFlag &&
                            <span className='pa thisTospan1'>
                              {item.name === '课题管理' ? proNumAll : item.name === '报告管理' ? this.props.badgeNum.reportNum : item.name === '行政管理' ? trainNum : item.name === '试剂耗材' ? medicineAll : item.name === '仪器设备' ? eqAdminAll : item.name === '经费管理' ? this.props.badgeNum.fundsNum : item.name === '文件私盘' ? this.props.badgeNum.reqPdInteger : 0}
                            </span>}
                          {frFlag && <span className='pa thisTospan'></span>}
                        </span>
                      }
                      {item.name === '报告管理' && reportFlag &&
                        <span>
                          {!frFlag &&
                            <span className='pa thisTospan1'>
                              {item.name === '课题管理' ? proNumAll : item.name === '报告管理' ? this.props.badgeNum.reportNum : item.name === '行政管理' ? trainNum : item.name === '试剂耗材' ? medicineAll : item.name === '仪器设备' ? eqAdminAll : item.name === '经费管理' ? this.props.badgeNum.fundsNum : item.name === '文件私盘' ? this.props.badgeNum.reqPdInteger : 0}
                            </span>}
                          {frFlag && <span className='pa thisTospan'></span>}
                        </span>
                      }
                      {item.name === '经费管理' && fundsFlag &&
                        <span>
                          {!frFlag &&
                            <span className='pa thisTospan1'>
                              {item.name === '课题管理' ? proNumAll : item.name === '报告管理' ? this.props.badgeNum.reportNum : item.name === '行政管理' ? trainNum : item.name === '试剂耗材' ? medicineAll : item.name === '仪器设备' ? eqAdminAll : item.name === '经费管理' ? this.props.badgeNum.fundsNum : item.name === '文件私盘' ? this.props.badgeNum.reqPdInteger : 0}
                            </span>}
                          {frFlag && <span className='pa thisTospan'></span>}
                        </span>
                      }
                      {item.name === '仪器设备' && equipmentFlag &&
                        <span>
                          {!frFlag &&
                            <span className='pa thisTospan1'>
                              {item.name === '课题管理' ? proNumAll : item.name === '报告管理' ? this.props.badgeNum.reportNum : item.name === '行政管理' ? trainNum : item.name === '试剂耗材' ? medicineAll : item.name === '仪器设备' ? eqAdminAll : item.name === '经费管理' ? this.props.badgeNum.fundsNum : item.name === '文件私盘' ? this.props.badgeNum.reqPdInteger : 0}
                            </span>}
                          {frFlag && <span className='pa thisTospan'></span>}
                        </span>
                      }
                      {item.name === '试剂耗材' && reagentFlag &&
                        <span>
                          {!frFlag &&
                            <span className='pa thisTospan1'>
                              {item.name === '课题管理' ? proNumAll : item.name === '报告管理' ? this.props.badgeNum.reportNum : item.name === '行政管理' ? trainNum : item.name === '试剂耗材' ? medicineAll : item.name === '仪器设备' ? eqAdminAll : item.name === '经费管理' ? this.props.badgeNum.fundsNum : item.name === '文件私盘' ? this.props.badgeNum.reqPdInteger : 0}
                            </span>}
                          {frFlag && <span className='pa thisTospan'></span>}
                        </span>
                      }
                      {item.name === '文件私盘' && pdFileFlag &&
                        <span>
                          {!frFlag &&
                            <span className='pa thisTospan1'>
                              {item.name === '课题管理' ? proNumAll : item.name === '报告管理' ? this.props.badgeNum.reportNum : item.name === '行政管理' ? trainNum : item.name === '试剂耗材' ? medicineAll : item.name === '仪器设备' ? eqAdminAll : item.name === '经费管理' ? this.props.badgeNum.fundsNum : item.name === '文件私盘' ? this.props.badgeNum.reqPdInteger : 0}
                            </span>}
                          {frFlag && <span className='pa thisTospan'></span>}
                        </span>
                      }
                      {/* <Badge className='myBadge'
                        count={
                          item.name === '课题管理' ? this.state.proNumAll : item.name === '报告管理' ? badge.reportNum : item.name === '行政管理' ? this.state.trainNum : item.name === '试剂耗材' ? this.state.medicineAll : item.name === '仪器设备' ? this.state.eqAdminAll : item.name === '经费管理' ? badge.fundsNum : 0
                          // item.value
                        }
                        dot={
                          item.name === '课题管理' ? this.state.proNumAll === 0 ? false : this.state['msgFlag' + item.value] : item.name === '报告管理' ? badge.reportNum === 0 ? false : this.state['msgFlag' + item.value] : item.name === '行政管理' ? this.state.trainNum === 0 ? false : this.state['msgFlag' + item.value] : item.name === '试剂耗材' ? this.state.medicineAll === 0 ? false : this.state['msgFlag' + item.value] : item.name === '仪器设备' ? this.state.eqAdminAll === 0 ? false : this.state['msgFlag' + item.value] : item.name === '经费管理' ? badge.fundsNum === 0 ? false : this.state['msgFlag' + item.value] : 0
                        }
                      > */}
                      <i className={`iconfont ${item.icon ? item.icon : 'icon-ziyuan'} ${screen.width == 1440 ? 'mr0 f20' : 'mydataIcon'}`}></i>

                      <br />
                      <span className='isSpan'>{item.name}</span>
                      {/* </Badge> */}
                    </span>
                  } popupClassName='body_subMenu'>
                    <Menu.Item className="title"><span className='isSpan'>{item.name}</span></Menu.Item>
                    {item.subMenu.map(val => {
                      return (
                        <Menu.Item key={val.value} className='mytoVertical'>
                          <Link to={val.link}>
                            <Badge className='myBadge2'
                              count={
                                val.name === '课题项目' ? badge.proNum : val.name === '工作汇报' ? badge.workReport : val.name === '行政管理' ? this.state.trainNum : val.name === '试剂耗材库' ? badge.reagentNum : val.name === '我的报告' ? badge.reportNum : val.name === '培训/会议' ? badge.trainNum : val.name === '问卷调查' ? badge.questionnaireNum : val.name === '申领审批' ? badge.reagentApplyNum : val.name === '申购审批' ? badge.reagentbuyNum : val.name === '报账审批' ? badge.fundsNum : val.name === '预约审批' ? badge.eqApplyNum : val.name === '仪器设备库' ? badge.noBackBespeak : val.name === '故障报修' ? badge.repairEqNum : val.name === '共享盘审核' ? badge.reqPdInteger : val.name === '会议室预约' ? badge.meetingEqNum : 0
                              }
                              // dot={this.state['msgFlag' + item.value]}
                              overflowCount={99}

                            >
                              {val.name}
                            </Badge>
                          </Link>
                        </Menu.Item>
                      )
                    })}
                  </SubMenu>
                )
              }
            })}
          </Menu>
        </Scrollbars >
        <Row className={`${styles.bottomMenu} bottomMenu`}>
          {/* <Col className='msg_badge mb5'>
            <Badge dot={this.props.msgNum > 0} overflowCount={99}>
              <Link to='/msg'>
                <i className="iconfont icon-fasongyoujian f20"></i>
              </Link>
            </Badge>
          </Col> */}
          <Col className='mb5'>
            {(settingMenu && settingMenu.subMenu && settingMenu.subMenu.length > 0) &&
              <Popover placement="right" trigger="hover" content={settingMenus}>
                <a><i className="iconfont icon-shezhi f20"></i></a>
              </Popover>
            }
          </Col>
          {/* <Col className='mb5'>
            <Popover placement="right" content={userMenu}>
              <a className="f12">
                <Avatar size={38} src={this.props.user ? (servers.basePath + this.props.user.userObj.headPath) : servers.defaultAvator} style={{ backgroundColor: '#b6dbaf' }} icon="user" />
                <br />{this.props.user && this.props.user.nickName}
              </a>
            </Popover>
          </Col> */}
          <Col className='mb5'>
            <Popover placement="right" trigger="hover" content={helpMenus}>
              <a onClick={() => this.showRule()}>
                <Icon type="question-circle" className={styles.credit_showRule + ' f16'} />
              </a>
            </Popover>
          </Col>
        </Row>
      </Sider >
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    selectBox: state.selectBox,
    msgNum: state.msgNum,
    badgeNum: state.badgeNum
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...userActions, ...boxActions, ...msgNumActions, ...badgeActions, ...appActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SiderMenu);
